// src/components/Timeline.js
import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../css/Timeline.css';

export default function Timeline({ versions, onFeatureClick, ltsOnly }) {
  // Determine which releases to display
  const ltsVersions = ['8', '11', '17', '21'];
  const displayVersions = ltsOnly
    ? versions.filter(v => ltsVersions.includes(v.version))
    : versions;

  // Empty state when no standard filters are selected
  if (!ltsOnly && displayVersions.length === 0) {
    return (
      <div className="timeline-empty">
        No filters have been selected.
      </div>
    );
  }

  // Empty state when LTS only is selected but no LTS releases found
  if (ltsOnly && displayVersions.length === 0) {
    return (
      <div className="timeline-empty">
        No LTS versions available. You need to select either Incubator, Preview or Final.
      </div>
    );
  }

  return (
    <div className="timeline-container">
      <VerticalTimeline>
        {displayVersions.map(({ version, date, features, blogPost }) => {
          const hasLink = Boolean(blogPost);
          return (
            <VerticalTimelineElement
              key={version}
              date={date}
              iconStyle={{
                background: 'var(--color-primary)',
                color: '#fff'
              }}
              contentStyle={{
                borderTop: '3px solid var(--color-primary)',
                background: '#fff',
                color: 'var(--color-text)'
              }}
            >
              <h3 className="release-title">
                {hasLink ? (
                  <button
                    className="release-button"
                    type="button"
                    onClick={() => window.open(blogPost, '_blank', 'noopener')}
                  >
                    Java {version}
                  </button>
                ) : (
                  <span className="release-text">
                    Java {version}
                  </span>
                )}
                {ltsOnly && ltsVersions.includes(version) && (
                  <span className="lts-badge"> (LTS)</span>
                )}
              </h3>
              <ul className="feature-list">
                {features.map((feat, i) => (
                  <li key={i}>
                    <button
                      className="feature-btn"
                      type="button"
                      onClick={() =>
                        onFeatureClick(
                          feat.metadata.feature_name.replace(/\s*\((preview|incubator)\)$/i, '')
                        )
                      }
                    >
                      {feat.metadata.feature_name}
                    </button>
                  </li>
                ))}
              </ul>
            </VerticalTimelineElement>
          );
        })}
      </VerticalTimeline>
    </div>
  );
}
